import {
    Account,
    Appwrite,
    Storage,
    Teams,
    Functions,
    Databases,
  } from "@refinedev/appwrite";

  const APPWRITE_URL = `${process.env.REACT_APP_appwriteUrl}/v1`;
  const APPWRITE_PROJECT = `${process.env.REACT_APP_appwriteProject}`;
  
  const appwriteClient = new Appwrite();
  
  appwriteClient.setEndpoint(APPWRITE_URL).setProject(APPWRITE_PROJECT);
  
  const account = new Account(appwriteClient);
  const storage = new Storage(appwriteClient);
  const teams = new Teams(appwriteClient);
  const functions = new Functions(appwriteClient);
  const database = new Databases(appwriteClient);
  
  export { appwriteClient, account, storage, teams, functions, database };
  
